import { Checkbox, Typography } from '@sanlam-glacier/app-common/components';
import { Block, Grid } from '@sanlam-glacier/app-common/modules/grid';
import { PrettyPrintJson } from 'dev-tools/components/pretty-print-json/PrettyPrintJson';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { useConfig } from 'providers/config/ConfigProvider';
import styles from './dev-tools-env.module.scss';

export const DevToolsEnv = () => {
  const env = useConfig();
  const [stepperOverride, setStepperOverride] = useLocalStorage(
    'overrideStepper',
    env.featureFlags.stepperFeatureToggle
  );

  const [forceEnableESign, setForceEnableESign] = useLocalStorage(
    'forceEnableESign',
    env.featureFlags.forceEnableESign
  );

  return (
    <Grid>
      <Block sm={12} className={styles.envSettings}>
        <Typography variant={Typography.VARIANT.B1}>Env Overrides</Typography>
        <Checkbox
          checked={stepperOverride}
          onChange={(checked) => setStepperOverride(checked === Checkbox.CHECKBOX.CHECKED)}
        >
          Unlock stepper
        </Checkbox>
        <Checkbox
          checked={forceEnableESign}
          onChange={(checked) => setForceEnableESign(checked === Checkbox.CHECKBOX.CHECKED)}
        >
          Force enable E-Sign
        </Checkbox>
      </Block>
      <Grid row>
        <PrettyPrintJson jsonData={env} />
      </Grid>
    </Grid>
  );
};
